<template>
  <div class="section">
    <div class="field">
      <label class="label">Service</label>
      <div class="control">
        <div class="select">
          <select v-model="service">
            <option value="">Select Service</option>
            <option v-for="(service_row, index) in service_list" :key="index" :value="service_row.id" v-text="service_row.title"></option>
          </select>
        </div>
      </div>
    </div>
    <div class="field">
      <label class="label">Date</label>
      <div class="control">
        <input type="date" class="input" v-model="input_date">
      </div>
    </div>
    <div class="field is-grouped">
      <div class="control">
        <button class="button is-link" @click="getSummary()">Get Summary</button>
      </div>
    </div>
    <h3 class="title is-3">Giving</h3>
    <table class="table is-bordered is-fullwidth">
      <tr>
        <th></th>
        <th class="has-text-centered" colspan="2">BCA</th>
        <th class="has-text-centered" colspan="2">MayBank</th>
        <th></th>
      </tr>
      <tr>
        <th></th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Total</th>
      </tr>
      <tr v-for="(data_row, index) in giving_list" :key="index">
        <td v-for="(data_detail, index_detail) in data_row" :key="index_detail" :class="{'content-bold': data_detail.bold === 1, 'cell-grey': data_detail.color === 'grey', 'cell-green': data_detail.color === 'green'}" v-text="data_detail.total"></td>
      </tr>
    </table>
    <h3 class="title is-3">Event</h3>
    <table class="table is-fullwidth">
      <tr>
        <th>Event</th>
        <th>Start Tickets</th>
        <th>Sold Tickets</th>
        <th>Remaining Tickets</th>
      </tr>
      <tr v-for="(event_row, index) in event_list" :key="index">
        <td v-text="event_row.title"></td>
        <td v-text="event_row.start_tickets"></td>
        <td v-text="event_row.sold_tickets"></td>
        <td v-text="event_row.remaining_tickets"></td>
      </tr>
    </table>
    <h3 class="title is-3">Event Complimentary</h3>
    <table class="table is-fullwidth">
      <tr>
        <th>Event Complimentary</th>
        <th>Start Tickets</th>
        <th>Sold Tickets</th>
        <th>Remaining Tickets</th>
      </tr>
      <tr v-for="(event_row, index) in event_complimentary_list" :key="index">
        <td v-text="event_row.title"></td>
        <td v-text="event_row.start_tickets"></td>
        <td v-text="event_row.sold_tickets"></td>
        <td v-text="event_row.remaining_tickets"></td>
      </tr>
    </table>
    <h3 class="title is-3">Settlement</h3>
    <table class="table is-bordered is-fullwidth">
      <tr>
        <th></th>
        <th class="has-text-centered" colspan="2">BCA</th>
        <th class="has-text-centered" colspan="2">MayBank</th>
      </tr>
      <tr>
        <th></th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
      </tr>
      <tr v-for="(data_row, index) in settlement_list" :key="index">
        <td v-for="(data_detail, index_detail) in data_row" :key="index_detail" :class="{'content-bold': data_detail.bold === 1, 'cell-grey': data_detail.color === 'grey', 'cell-green': data_detail.color === 'green'}" v-text="data_detail.total"></td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      input_date: '',
      service_list: [],
      service: '',
      giving_list: [],
      event_list: [],
      event_complimentary_list: [],
      settlement_list: []
    }
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }

    this.getService()
  },
  methods: {
    getService () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGet('new_people/get_services')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.service_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getSummary () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('summary/get_service_data', {
        date: this.input_date,
        service: this.service
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.event_list = response.data.data.event_list
          self.event_complimentary_list = response.data.data.event_complimentary_list
          self.giving_list = response.data.data.giving_list
          self.settlement_list = response.data.data.settlement_list
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/frontdesk/summary/Service.vue